export default function scrollToItem() {
    /*
    // Handle anchor links with hash and same origin
    document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(function(link) {
        link.addEventListener('click', function(event) {
            const href = this.getAttribute('href');
            if (location.pathname.replace(/^\//, '') === href.replace(/^\//, '') && location.hostname === this.hostname) {
                const target = document.querySelector(href) || document.querySelector(`[name="${href.slice(1)}"]`);
                if (target) {
                    const navbarHeight = document.querySelector('.navbar.fixed-top, header.fixed-top')?.offsetHeight || 0;
                    window.scrollTo({
                        top: target.offsetTop - navbarHeight,
                        behavior: 'smooth'
                    });
                    event.preventDefault(); // Prevent default anchor link behavior
                }
            }
        });
    });
    */
    /*
    // Handle collapse elements with data-toggle="collapse" attribute
    document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function(toggleButton) {
        toggleButton.addEventListener('click', function() {
            const collapseTargetId = this.getAttribute('data-bs-target');
            const collapseTarget = document.querySelector(collapseTargetId);
            const navbarHeight = document.querySelector('header.fixed-top')?.offsetHeight || 0;

            // Bind scroll event to collapseTarget after it's retrieved
            if (collapseTarget) {
                collapseTarget.addEventListener('shown.bs.collapse', function() {
                    console.log("collapseTarget.offsetTop - navbarHeight: "+ (collapseTarget.offsetTop - navbarHeight));
                    console.log("navbarHeight: " + navbarHeight);
                    console.log("collapseTarget: "+ collapseTarget); // Now logs the element object
                    console.log("collapseTargetId: "+ collapseTargetId);
                    console.log("collapseTarget.offsetTop: "+ collapseTarget.offsetTop);
                    window.scrollTo({
                        top: (collapseTarget.offsetTop - navbarHeight),
                        behavior: 'smooth'
                    });
                });
            }

        });
    });

    // Handle accordion elements with .accordion class
*/
    document.querySelectorAll('.accordion').forEach(function(accordion) {
        accordion.addEventListener('shown.bs.collapse', function(event) {
            // Das Element, das gerade geöffnet wird
            const target = event.target.parentElement;

            // Header Höhe dynamisch ermitteln
            const navbar = document.querySelector('.navbar.fixed-top, header.fixed-top, header.sticky-top');
            const navbarHeight = navbar ? navbar.offsetHeight : 0;

            // Sicherheits-Timeout, damit das DOM bereit ist
            setTimeout(() => {
                const rect = target.getBoundingClientRect();
                const absoluteTop = rect.top + window.pageYOffset;

                window.scrollTo({
                    top: absoluteTop - navbarHeight - 20, // 20px Puffer für Optik
                    behavior: 'smooth'
                });
            }, 10);
        });
    });
}
